import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { getGender } from 'src/common/utils/gender';
import DemographicInfoDisplay from './DemographicInfoDisplay';

function ContactDetailReviewDemographic(props) {
  const people = _.get(props.enums, 'people', {});
  const {
    values: {
      gender, marital_status, race, ethnicity,
    },
    limitedGenderOptions,
  } = props;
  const modifiedGender = getGender({ gender, flag: limitedGenderOptions });

  if (_.isEmpty(people)) { return null; }

  return (
    <div className="contact-details-review-demographic confirmed-details__row">
      <DemographicInfoDisplay value={modifiedGender} label="Gender" enumsPeopleArray={people.genders} />
      <DemographicInfoDisplay
        value={marital_status}
        label="Marital Status"
        enumsPeopleArray={people.marital_status}
      />
      <DemographicInfoDisplay value={race} label="Race" enumsPeopleArray={people.race} />
      <DemographicInfoDisplay value={ethnicity} label="Ethnicity" enumsPeopleArray={people.ethnicity} />
    </div>
  );
}

ContactDetailReviewDemographic.propTypes = {
  enums: PropTypes.object,
  values: PropTypes.object,
  limitedGenderOptions: PropTypes.bool,
};

export default ContactDetailReviewDemographic;
